import React, { createContext, FC, useEffect, useState } from 'react';

export interface IUserMonitorProvided {
    hasInteracted: boolean;
}

export const UserMonitorContext = createContext<IUserMonitorProvided | undefined>(undefined);

export const UserMonitorContextProvider: FC<object> = ({children}) => {

    const [monitor, setMonitor] = useState<IUserMonitorProvided>({hasInteracted: false});

    const handleUserInteractivity = () => {
        setMonitor({...monitor, hasInteracted: true});
    }

    useEffect(() => {
        window.addEventListener('click', handleUserInteractivity);
        return () => {
            window.removeEventListener('click', handleUserInteractivity);
        }
    }, []);

    return(
        <UserMonitorContext.Provider value={monitor}>
            {children}
        </UserMonitorContext.Provider>
    )
}
